import React from 'react';
import { useRouter } from "next/router";
import Image from "next/image";
import Overlay from "src/components/Overlay/Overlay";
import AnimationHeading from "src/components/AnimationsTags/AnimationHeading/AnimationHeading";
import AnimationParagraph from "src/components/AnimationsTags/AnimationParagraph/AnimationParagraph";
import parse from "html-react-parser";
import StatisticsCount from "src/components/Sections/HomePage/StatisticsCount/StatisticsCount";
import ButtonAsLink from "src/components/ButtonAsLink/ButtonAsLink";
import Divider from "src/components/Divider/Divider";
import localesData, { ButtonLocales, DividerLocales, ButtonDividerLocales } from "./locales/data";

const OurPartnersSection = () => {
  const { locale } = useRouter();

  const additionalContent = {
    6: (
      <Divider additionalStyle="my-16">
        <p className="text-3xl lg:text-4xl font-semibold">{DividerLocales[locale].content_1}</p>
        <p className="text-xl p-0">{DividerLocales[locale].content_2}</p>
        <ButtonAsLink
          link="/contacts"
          styling="secondary_reverse"
          additionalStyle="mx-auto my-6"
          locales={ButtonDividerLocales}
        />
      </Divider>
    )
  }

  return (
    <>
      {localesData.map((item, idx) => {
        const currentLocale = item[locale];
        return (
          <section
            key={currentLocale.title}
            id={`partner-${idx + 1}`}
            className="px-4 py-12 xl:py-20"
          >
            <div className={`container mx-auto flex flex-col-reverse ${idx % 2 === 0 ? 'xl:flex-row' : 'xl:flex-row-reverse'}`}>
              <div className={`w-full xl:w-2/4 pr-0 mt-8 xl:mt-0 ${idx % 2 === 0 ? 'xl:pr-10' : 'xl:pl-10'}`}>
                <AnimationHeading
                  title={currentLocale.title}
                  size="text-2xl xl:text-4xl"
                  additionalStyle="lg:text-center uppercase tracking-wider"
                  margin="pb-4 xl:pb-10"
                />
                <AnimationParagraph>
                  {parse(currentLocale.content)}
                  <ButtonAsLink
                    link="/services"
                    styling="secondary_reverse"
                    additionalStyle="mx-auto mt-8  text-center lg:text-start"
                    locales={ButtonLocales}
                  />
                </AnimationParagraph>
              </div>
              <div className="w-full xl:w-2/4 pt-4 xl:pt-0 h-auto">
                <div className="relative w-full h-[300px] lg:h-[480px]">
                  <Image src={`/assets/sections/home/specificity/${currentLocale.image}`} alt="" layout="fill" objectFit="cover" />
                  <Overlay opacity="bg-opacity-40" />
                </div>
              </div>
            </div>
            <StatisticsCount data={currentLocale.count} />
            {additionalContent[idx] ?? null}
          </section>
        )
      })}
    </>
  );
};

export default OurPartnersSection;